import React, { useState } from "react";
import "./CoreArchitectsCarousel.css";
import ArchitectMessage from "./ArchitectMessage";
import { motion, AnimatePresence } from "framer-motion";
import bgGradient from "../../Assets/rock-bg.png";
const architects = [
  {
    image: require("../../Assets/leadership/rudramurthy.png"),
    name: "Mr. Rudramurthy",
    title: "CEO, VCNR Technologies",
    paragraphs: [
      "A technologist at heart and a strategist by mind, Mr. Rudramurthy is a great individual leading the group's innovation engine.",
      "With a background in software engineering and AI, he's building platforms that remote rural entrepreneurs and progressive enterprise.",
      "We didn’t just build businesses, we built bridges of opportunities."
    ],
  },
  {
    image: require("../../Assets/leadership/santhosh.jpg"),
    name: "Mr. Santosh",
    title: "CEO, VCNR Builders & Infrastructure",
    paragraphs: [
      "Mr. Santosh leads our infrastructure and construction verticals with a vision for sustainable growth.",
      "His leadership ensures every project is built to last and serves the community."
    ],
  },
  {
    image: require("../../Assets/leadership/vinya.jpg"),
    name: "Dr. Vinay",
    title: "CEO, VCNR Healthcare",
    paragraphs: [
      "Dr. Vinay is committed to delivering high-quality, accessible care to the underprivileged.",
      "His work at VCNR Healthcare is transforming lives and communities."
    ],
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  hover: { scale: 1.06, boxShadow: "0 8px 32px 0 #7b5cff44" }
};

export default function CoreArchitectsCarousel() {
  const [selectedIdx, setSelectedIdx] = useState(0);
  const selected = architects[selectedIdx];

  return (
    <div className="core-bg">
      <img src={bgGradient} alt="Background" className="build-bg" />
      <div className="core-architects-carousel">
        <h2 className="carousel-title">The Architects Behind VCNR</h2>
        <div className="architects-row">
          {architects.map((item, idx) => (
            <motion.div
              key={idx}
              className={`carousel-card${selectedIdx === idx ? " selected" : ""}`}
              onClick={() => setSelectedIdx(idx)}
              style={{ cursor: "pointer" }}
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              whileHover="hover"
              transition={{ type: "spring", stiffness: 120 }}
            >
              <div className="carousel-card-img-wrap">
                <img src={item.image} alt={item.name} className="carousel-card-img" />
              </div>
              <div className="carousel-card-name">
                {item.name}<br />{item.title}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <AnimatePresence mode="wait">
        <motion.div
          key={selectedIdx}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <ArchitectMessage
            image={selected.image}
            name={selected.name}
            title={selected.title}
            paragraphs={selected.paragraphs}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
} 